import { SharesTitle, Operation } from 'types';

type GetTitleByOperationProps = {
  sharesTitles: SharesTitle[];
  operation: Operation;
};

export const getTitleByOperation = ({
  sharesTitles,
  operation,
}: GetTitleByOperationProps) =>
  sharesTitles?.find(
    (title: SharesTitle) => title?.operation === operation?._id
  );
